import { render } from "./MyAccount.vue?vue&type=template&id=70fb9603&scoped=true"
import script from "./MyAccount.vue?vue&type=script&lang=js"
export * from "./MyAccount.vue?vue&type=script&lang=js"

import "./MyAccount.vue?vue&type=style&index=0&id=70fb9603&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70fb9603"]])

export default __exports__